import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractParams } from "@routes/types";

const pathBase = `/medical-service-provider/assigned-doctors/:mspId`;

export type IPathBaseParams = IExtractParams<typeof pathBase>;

export const assignedDoctors = {
  getAll: (params: IPathBaseParams) => generateApiPath(pathBase, params),
};
